var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart96-template',{attrs:{"board-ids":[628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639],"data-type":_vm.dataType,"graph-id":96,"title":"공중이용시설 안전인력 운용현황","unit":"명"}})
}
var staticRenderFns = []

export { render, staticRenderFns }